"use client";

import { Copy } from "iconsax-reactjs";
import { useCallback, useRef, useState } from "react";
import { Button, type ButtonProps } from "@/components/ui/button";
import { CheckIcon, type CheckIconHandle } from "@/components/ui/CheckIcon";
import { cn } from "@/lib/utils";

interface CopyAnimatedButtonProps {
  text: string;
  size?: number;
  className?: string;
  variant?: ButtonProps["variant"];
}

export const CopyAnimatedButton = ({
  text,
  size = 16,
  className,
  variant = "light",
}: CopyAnimatedButtonProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const checkIconRef = useRef<CheckIconHandle | null>(null);

  const handleCopy = useCallback(() => {
    setIsCopied(true);
    setTimeout(() => {
      checkIconRef.current?.startAnimation();
    }, 0);

    setTimeout(() => setIsCopied(false), 3000);
    navigator.clipboard.writeText(text);
  }, [text]);

  return (
    <Button
      type="button"
      size={"icon"}
      className={cn("p-0 text-inherit", className)}
      variant={variant}
      onClick={handleCopy}
    >
      {isCopied ? (
        <CheckIcon className="text-green-500" ref={checkIconRef} size={size} />
      ) : (
        <Copy size={size} />
      )}
    </Button>
  );
};
